<template>
  <header class="header clearfix">
    <nav style="margin-top:1em;">
      <ul class="nav nav-pills float-right">
        <li class="nav-item">
          <div class="nav-link">
          <span class="user-name" style="">{{ currentUser.displayName }}</span>
            <!--<span class="user-name" style="" @click.prevent="signOut()">{{currentUser.name}}</span>-->
            <span class="coinicon3"></span>
            <span class="learningPoints">{{userLearningPoints}}</span>
            <!--<span class="user-balance" style="">{{currentUser.balance}}$</span>-->
          </div>
        </li>
      </ul>
    </nav>

    <router-link class="navbar-brand" style="border: !important" :to="{path: '/'}">
      <span class="d-inline-block align-top logoImg" alt="" style="border:none !important"></span>
    </router-link>
  </header>
</template>

<script>
import Firebase from 'firebase'
import { store } from '../store/store.js'
import { dbUserCollectionRef } from './../firebaseConfig'

Firebase.auth().onAuthStateChanged(function(user) {
  if(user) {
    store.dispatch('setUser', user)
  } else {
    store.dispatch('setUser', null)
  }
});

export default {
  methods: {
  },
  computed: {
    currentUser(){
      return this.$store.getters.currentUser;
    },
    userLearningPoints(){
      var cUser = this.$store.getters.currentUser;
      var uC = this.$store.getters.getUserCollection;
      var learningPoints = "000"
      if(uC && cUser){
          var userData = uC.filter( newData => {
              return  (newData.uid == cUser.uid );
          });
          if (userData.length>0){
            if (userData[0].learningPoints){
              learningPoints = Math.ceil(userData[0].learningPoints)
            }
          }
      }
      if (learningPoints < 10 && learningPoints > 0 ) {
          learningPoints = ("0"+learningPoints);
      }
      if (learningPoints < 100 && learningPoints > 0 ) {
          learningPoints = ("0"+learningPoints);
      }
      return learningPoints;
    }
  },
    created() {
        this.$store.dispatch('setUserCollectionRef', dbUserCollectionRef)
    }
}
</script>

<style scoped>
.user-name{
  vertical-align: middle; font-weight: bold; color: rgba(0,0,0,.2);
}

.learningPoints {
  vertical-align: middle; 
  font-weight: bold; 
  color: #f2c300;
  margin-left: -5px;
  
}

.nav-link{
  padding: .5rem 0rem;
}
  

.header {
  padding-bottom: 0.5rem;
  border-bottom: .05rem solid #e5e5e5;
}


</style>


// WEBPACK FOOTER //
// src/components/AppHeader.vue